import { produce } from 'solid-js/store';
import type { ChangeTrackingSource } from '@typeDefinitions/changeTrackingTypes';

import {
  deleteFuelSurchargeCall,
  getFuelSurchargeCall,
  saveFuelSurchargeCall,
} from './services';
import { setFuelSurchargeStore } from './store';
import {
  FuelSurchargeData,
  FuelSurchargeRange,
  IFuelSurchargeStore,
} from './types';

export const getFuelSurchargeData = async (
  customerId: number,
  includeDeleted: boolean = false,
  overrideClick?: boolean,
  ownerType?: string,
) => {
  setFuelSurchargeStore('isLoading', true);
  const resp = await getFuelSurchargeCall(
    customerId,
    includeDeleted,
    ownerType!,
    () => {
      setFuelSurchargeStore('isLoading', false);
    },
  );

  if (Boolean(overrideClick) && resp) {
    if (Boolean(resp.isDefault)) {
      setFuelSurchargeStore(
        produce((state: IFuelSurchargeStore) => {
          state.fuelSurchargeData = {
            isDeleted: null,
            isDefault: false,
            eiaRegion: null,
            effectiveDay: null,
            fuelSurchargeRanges: [],
            type: 0,
            operationType: '',
          };
        }),
      );
    } else {
      setFuelSurchargeStore('fuelSurchargeData', {
        ...resp,
        isDeleted: false,
        fuelSurchargeRanges: createFuelSurchargeRange(resp.fuelSurchargeRanges),
      });
    }
  } else if (resp) {
    if (!Boolean(resp.isDefault)) {
      setFuelSurchargeStore(
        produce((state: IFuelSurchargeStore) => {
          state.fuelSurchargeData = {
            ...resp,
            fuelSurchargeRanges: createFuelSurchargeRange(
              resp.fuelSurchargeRanges,
            ),
          };
        }),
      );
    } else {
      setFuelSurchargeStore('fuelSurchargeData', resp);
    }
  }
};

export const deleteFuelSurchargeData = async (
  customerId: number,
  ownerType: string,
  changeTrackingSource?: ChangeTrackingSource,
) => {
  const resp = changeTrackingSource
    ? await deleteFuelSurchargeCall(customerId, ownerType, changeTrackingSource)
    : await deleteFuelSurchargeCall(customerId, ownerType);
  setFuelSurchargeStore('errors', []);
  resp && setFuelSurchargeStore('fuelSurchargeData', resp);
};

export const saveFuelSurcharge = async (
  customerId: number,
  model: FuelSurchargeData,
  ownerType?: string,
  changeTrackingSource?: ChangeTrackingSource,
) => {
  setFuelSurchargeStore('isLoading', true);
  const resp = changeTrackingSource
    ? await saveFuelSurchargeCall(
        customerId,
        model,
        ownerType,
        changeTrackingSource,
      )
    : await saveFuelSurchargeCall(customerId, model, ownerType);
  if (resp) {
    if (!Boolean(resp.isDefault)) {
      setFuelSurchargeStore(
        produce((state: IFuelSurchargeStore) => {
          state.fuelSurchargeData = {
            ...resp,
            fuelSurchargeRanges: createFuelSurchargeRange(
              resp.fuelSurchargeRanges,
            ),
          };
        }),
      );
    } else {
      setFuelSurchargeStore('fuelSurchargeData', resp);
    }
  }
  setFuelSurchargeStore('isLoading', false);
};

const createFuelSurchargeRange = (
  fuelSurchargeRanges: FuelSurchargeRange[],
) => {
  return fuelSurchargeRanges.map((item) => {
    return {
      ...item,
      surchargeModifier:
        item.type === 0
          ? parseFloat((item.surchargeModifier * 100).toFixed(2))
          : item.surchargeModifier,
    };
  });
};
